import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import classNames from 'classnames';
import { Loading, Toast } from '../../components';
import { cancelTurn, updateCancelStatus } from '../../redux/actions/turnActions';
import { MY_TURN_PATH } from '../../routes/path';
import './index.scss';

const DetailTurn = () => {
  const { user } = useSelector((state) => state.userReducer);
  const { error, cancelTurn: cancelTurnStatus } = useSelector(
    (state) => state.turnReducer
  );
  const dispatch = useDispatch();
  const { state } = useLocation();
  const navigate = useNavigate();

  const {
    id,
    medico: doctor,
    turno: { fecha_hora: date },
    obra_social: { nombre: healthInsuranceName },
    estado: status,
    isDisabled,
    isLoading
  } = state;
  const fecha = moment(date).locale('es').format('dddd D [de] MMMM [de] YYYY');
  const hours = moment(date).locale('es').format('HH:mm');
  const [isHovered, setIsHovered] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleHover = () => {
    setIsHovered(!isHovered);
  };

  useEffect(() => {
    if (cancelTurnStatus) {
      navigate(MY_TURN_PATH);
      dispatch(updateCancelStatus());
    }
  }, [cancelTurnStatus]);

  if (isLoading) return <Loading />;

  const handleConfirmCancelTurn = () => {
    dispatch(cancelTurn(id));
    setShowConfirm(false);
  };

  return (
    <div
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
      className={classNames('container-confirm', {
        'container-confirm--hovered': isHovered, past: isDisabled, confirmed: status === 'confirmada', canceled: status === 'cancelada'
      })}
    >
      <Toast error={error} />
      {showConfirm && (
        <div className="popup">
          <div className="popup-content">
            <h2>¿Estás seguro que deseas cancelar el turno?</h2>
            <div className="popup-buttons">
              <button className="confirm" onClick={handleConfirmCancelTurn}>Sí, cancelar turno</button>
              <button className="cancel" onClick={() => setShowConfirm(false)}>No, volver</button>
            </div>
          </div>
        </div>
      )}
      <div className="info">
        <div className="datos1 detailTurn">
          <div>
            <div className="state-detailTurn">
              <h3>Estado:</h3>
              <p className="status">{status.toUpperCase()}</p>
            </div>
            <div className="doctor doctor-detailTurn">
              <h5 className="subtitle">Médico</h5>
              <div className="container-doctor">
                <img
                  src={`${process.env.REACT_APP_BACKEND_URL}${doctor.foto_sm_url}`}
                  alt={`Dr. ${doctor.nombre} ${doctor.apellido}`}
                  className="img-doctor img-doctor-detailTurn "
                />
                <div className="name-specialty">
                  <p className="doctor-name">{`Dr. ${doctor.nombre} ${doctor.apellido}`}</p>
                  <p className="doctor-specialty">{doctor.especialidad}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="dates-detailTurn">
            <h3>Sus datos</h3>
            <p>
              {user.apellido}
              ,
              {user.nombre}
            </p>
            <p>{user.dni}</p>
            <p>{user.email}</p>
            <p>{user.telefono}</p>
          </div>
        </div>
        <div className="datos1 dataTurn-detailTurn">
          <div>
            <h3>Turno</h3>
            <div className="date-turnhour">
              <p>{fecha}</p>
              <p>{hours}</p>
            </div>
          </div>
          <div className="healt-detailTurn">
            <h3>Obra Social</h3>
            <p>{healthInsuranceName}</p>
          </div>
        </div>
      </div>
      {!isDisabled && (
        <div className="button-box">
          <button onClick={() => setShowConfirm(true)} className="buttonDetail-turn-confirm">Cancelar turno</button>
        </div>
      )}
    </div>
  );
};
export default DetailTurn;
